export var GenderType;
(function (GenderType) {
    GenderType["M"] = "male";
    GenderType["G"] = "gelding";
    GenderType["F"] = "female";
})(GenderType || (GenderType = {}));
//# sourceMappingURL=GenderType.js.map